export const CAMPAIGN_STATUS_ORDER = [
  'campaign_initiated',
  'task_accepted',
  'creative_production',
  'creative_approved',
  'publishing',
  'completed',
];

export const CAMPAIGN_STATUS_LABELS = {
  campaign_initiated: 'Campaign Initiated',
  task_accepted: 'Task Accepted',
  creative_production: 'Creative Production',
  creative_submission: 'Creative Submitted',
  creative_approved: 'Creative Approved',
  publishing: 'Publishing',
  completed: 'Completed',
};

const LEGACY_STATUS_MAP = {
  received: 'campaign_initiated',
  assign_creative: 'creative_production',
  creative_received: 'creative_production',
  creative_done: 'creative_approved',
};

export function normalizeCampaignStatus(status) {
  const normalized = String(status || '').trim().toLowerCase();
  if (CAMPAIGN_STATUS_ORDER.includes(normalized)) {
    return normalized;
  }
  return LEGACY_STATUS_MAP[normalized] || normalized;
}

export function campaignStatusLabel(status) {
  const normalized = normalizeCampaignStatus(status);
  return CAMPAIGN_STATUS_LABELS[normalized] || normalized || '-';
}

export function canAcceptCampaign(status) {
  return normalizeCampaignStatus(status) === 'campaign_initiated';
}

export function canAssignCreative(status) {
  return normalizeCampaignStatus(status) === 'task_accepted';
}

export function canApproveCreative(status) {
  return normalizeCampaignStatus(status) === 'creative_production';
}

export function canPublishCampaign(status) {
  const normalized = normalizeCampaignStatus(status);
  return normalized === 'creative_approved' || normalized === 'publishing';
}

export function isCampaignCompleted(status) {
  return normalizeCampaignStatus(status) === 'completed';
}